import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import {
  Tooltip,
  Row,
  Radio,
  Card,
  Select,
  Form,
  Col,
  Divider,
  Spin,
} from "antd";

//OTHER IMPORTS
import { BOM } from "../../services/definedMethod";
import cnt from "../../services/definedConstant";
import MainLayout from "../../components/layouts/MainLayout";
import TopContent from "../../components/layouts/TopContent";
import CustomButton from "../../components/custom/CustomButton";
import { apiConfig, labelConfig, staticConfig } from "./security.config";
import { showCheckerApprovalModal } from "../../components/CheckerModal";

const PasswordPreferences = (props) => {
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();

  const [isLoading, setIsLoading] = useState(false);
  const [value, setValue] = useState(null);
  const [description, setDescription] = useState("");

  useEffect(() => {
    getTemplate();
  }, []);

  function getTemplate() {
    const url = `${apiConfig.PasswordPreferences}/template`;

    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        const objList = res;

        const defaultId = objList.find((obj) => obj.active === true).id;
        setValue(defaultId);
        setDescription(objList.find((obj) => obj.id === defaultId).description);
        form.setFieldsValue({
          secure: defaultId,
        });
      }
    });
  }

  const onChange = (idParam) => {
    setValue(idParam.target.value);
  };

  const onSubmit = (formValues) => {
    const url = `${apiConfig.PasswordPreferences}`;

    formValues.validationPolicyId = value;

    delete formValues.simple;
    delete formValues.secure;

    const body = {
      ...formValues,
      method: "PUT",
      session,
    };

    // return
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.passwordPreferenceMsg);
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          // navigate(0);
          setIsLoading(false);
        },
      }
    );
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.managePasswordPreferences}
        pageItems={staticConfig.passwordPreferencesBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={form} onFinish={onSubmit}>
            <Row>
              <Col style={{ padding: "0px 8px" }}>
                <Form.Item name="secure">
                  <Radio.Group
                    defaultValue={value}
                    options={[
                      // { value: 1, label: labelConfig.simple },
                      { value: 2, label: description },
                    ]}
                    onChange={onChange}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Divider />
              {BOM.HasPermission("UPDATE_PASSWORD_PREFERENCES") && (
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#15CCAE"
                  colorText="black"
                  hoverBackground="#4FECA0"
                />
              )}
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

export default PasswordPreferences;
